export enum TradeAreaSearchType {
  DISTANCE = 'distance',
  TRAVEL_TIME = 'travelTime',
  GEOSPATIAL = 'geospatialSearch',
}

export const GEOSPATIAL_SEARCH_FIELDS = [
  'countryCode',
  'geohierarchyLevel',
  'geoIds',
  'geoNames',
];

export const DISTANCE_FIELDS = ['latitude', 'longitude', 'radius', 'unit'];

export const TRAVEL_TIME_FIELDS = [
  'lat',
  'lng',
  'travel_time',
  'transportation',
  'departure_time',
  'geohierarchyLevels',
];

export const ALL_TRADE_AREA_FIELDS = [
  ...GEOSPATIAL_SEARCH_FIELDS,
  ...DISTANCE_FIELDS,
  ...TRAVEL_TIME_FIELDS,
];
